<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Duomenų naikinimo aktai') }}</h1>
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!--main custom templates -->
      <template #[`item.status`]="{ item }">
        <el-busena :busena="item.status" />
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="setItemParam(item)"
            @downloadItem="download(item)"
            @destroyDataItem="destroyItem(item)"
            @inputDVSItem="inputDVS(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <!-- modals -->
    <modal-destroy-data
      v-model="showDestroy"
      :item="modalDestroyItem"
      @listUpdate="listUpdate"
    />
    <modal-input-DVS
      v-model="showInputDVS"
      v-if="showInputDVS"
      :item="modalInputDVSItem"
      @listUpdate="listUpdate"
    />
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import tableParameters from '@/mixins/tableParameters'
import math from '@/mixins/math'
import ModalDestroyData from '@/components/modals/ModalDestroyData'
import ModalInputDVS from '@/components/modals/ModalInputDVS'
export default {
  name: 'DataDestructionActs',
  components: { ModalDestroyData, ModalInputDVS },
  mixins: [userRole, math, tableParameters],
  data() {
    return {
      pageloading: true,
      loading: false,
      paginationloading: false,
      listData: [],
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 10,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      tableClassifiers: [],
      modalDestroyItem: {},
      showDestroy: false,
      modalInputDVSItem: {},
      showInputDVS: false,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Eil. Nr.'),
          align: 'start',
          value: 'number',
        },
        {
          text: this.$t('Akto sukūrimo data'),
          align: 'start',
          value: 'date',
        },
        {
          text: this.$t('Aktą sugeneravęs asmuo'),
          align: 'start',
          value: 'person',
        },
        {
          text: this.$t('Akto būsena'),
          align: 'start',
          value: 'status',
        },
        {
          text: this.$t('Akto DVS numeris'),
          align: 'start',
          value: 'dvs_number',
        },
        {
          text: this.$t('DVS registracijos data'),
          align: 'start',
          value: 'dvs_date',
        },
        {
          text: this.$t('Duomenų naikinimo data'),
          align: 'start',
          value: 'destruction_date',
        },
        {
          text: this.$t('Duomenis naikinęs asmuo'),
          align: 'start',
          value: 'who_destroyed',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    // this.setlistParams()
  },
  methods: {
    listUpdate(){
      this.getData()
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
      }

      this.$axios
        .post(`destruction-acts/list`, data)
        .then((res) => {
          this.listData = res.data.destructionActs
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
        page: pagination.page,
        route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    setItemParam(item) {
      // item.canDestroyData = true
      // item.canInputDVS = true
      return item
    },
    destroyItem(item) {
      this.modalDestroyItem = Object.assign({}, item)
      this.showDestroy = true
    },
    inputDVS(item) {
      this.modalInputDVSItem = Object.assign({}, item)
      this.showInputDVS = true
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.upload_id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    rowClass(item) {
      if (item.status === 'warning') {
        return `status-warning`
      }
      if (item.status === 'outdate') {
        return `status-outdate`
      }
      if (item.status === 'repost') {
        return `status-repost`
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
